<mat-drawer-container [hasBackdrop]="false" data-testid="page" style="height: 100vh">
  >
  <mat-drawer [opened]="true" data-testid="navigationMenu" mode="side" style="background: var(--side-nav-background)">
    <app-side-navigation></app-side-navigation>
  </mat-drawer>

  <mat-drawer-content data-testid="children" style="background: var(--background)">
    <router-outlet/>
  </mat-drawer-content>


</mat-drawer-container>
